import type { DataHubActionTypes } from 'src/modules/datahub/actions'
import type { DataHubEntityTypes } from 'src/modules/datahub/entities'
import { Platform } from 'src/modules/datahub/types'
import { UAParser } from 'ua-parser-js'

import type { SchemaType } from './types'

abstract class BaseSchema implements SchemaType {
  abstract action: DataHubActionTypes
  abstract entity: DataHubEntityTypes

  osVersion: string
  appVersion: string
  platformDetail: string
  platform: `${Platform}`

  constructor() {
    const userAgentParser = UAParser(navigator.userAgent)
    const browserInfo = userAgentParser.browser

    this.platform = Platform.WEB
    this.osVersion = browserInfo.version ?? ''
    this.platformDetail = browserInfo.name ?? ''
    this.appVersion = process.env.PROJECT_VERSION ?? ''
  }

  prepare(): Record<string, string> {
    return {
      platform: this.platform,
      osVersion: this.osVersion,
      appVersion: this.appVersion,
      url: window.location.href,
      platformDetail: this.platformDetail
    }
  }

  abstract getDataHubEventData(): Record<string, unknown>
}

export default BaseSchema
